"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { installOrderNotificationGestureUnlock } from "@app/[branch_id]/dining/[restaurantId]/(resturantsPages)/orders/hooks";

/**
 * Arms a one-shot document gesture unlock so clicking anywhere in the admin
 * (e.g. sidebar → Orders) unlocks kitchen sounds without the blocking gate.
 */
export function DiningOrderAudioGestureUnlock() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  installOrderNotificationGestureUnlock();
}